export const installationRoles = [
  { value: "", label: "None" },
  { value: "manager", label: "Manager" },
  { value: "installer", label: "Installer" },
  { value: "scanner", label: "Scanner" },
];
